//-----------------------------------------------------------------------------
// Copyright 2021-2025 by banbutsu dcp GmbH. Confidential. All rights reserved.
//-----------------------------------------------------------------------------
// Project: platform frontend
// Author:  thomas.driemeyer@banbutsu.com
//
// German translations. The first string in every pair is passed to the
// translate function, looked up here, and replaced with the second string.
//-----------------------------------------------------------------------------

export const translationsDE = new Map<string, string>([
    ["What are you interested in?", "Was Interessiert Dich?"],
    ["Design Your Trip", "Plane Deinen Trip"],
    ["Sorry, a server problem", "Entschuldigung, es ist ein Serverproblem aufgetreten"],
    ["Preparing your selection", "Deine Auswahl wird szusammengestellt"],
    ["Continue", "Weiter"],
    ["Select a package first", "Bitte Paket auswählen"],
    ["Please refresh the page", "Bitte aktualisiere die Seite"],
    ["Apply changes", "Weiter"],
    ["server error package", "Entschuldigung, es gibt ein Problem bei der Zusammenstellung"],
    ["Please go back and try again", "Bitte gehe zurück und versuche es erneut"],
    ["error creating booking", "Leider ist ein Fehler bei der Bestätigung der Buchung aufgetreten"],
    ["Go Back", "Zurück"],
    ["Your shopping cart", "Dein Warenkorb"],
    ["final look at your orders", "Schau Dir die Bestellungen noch einmal an und ergänze die Buchungsdaten, bevor Du zur Zahlung gehst."],
    ["Adult", "Erwachsener"],
    ["Adults", "Erwachsene"],
    ["Total (incl. VAT)", "Gesamtsumme (inkl.&nbsp;MwSt.)"],
    ["map rendering problem", "Entschuldigung, es ist ein Problem mit der Karte aufgetreten."],
    ["Your booking locations", "Deine Buchungsorte"],
    ["confirm payment", "Zahlung bestätigen"],
    ["Sorry error creating booking", "Leider ist ein Fehler bei der Bestätigung der Buchung aufgetreten"],
    ["Please refresh and try again", "Bitte aktualisiere die Seite und versuche es noch einmal"],
    ["error booking confirmation", "Leider ist bei der Bestätigung der Buchung ein Fehler aufgetreten."],
    ["Please try again. We sincerly apologise", "Bitte aktualisiere die Seite und versuche es erneut. Aktualisieren und fortsetzen"],
    ["Back to start page", "Zur Startseite"],
    ["PAYMENT CONFIRMATION", "ZAHLUNGSBESTÄTIGUNG"],
    ["about to pay the following items", "Die folgenden Beträge werden an die aufgeführten Einzelhandels- und Dienstleistungspartner übermittelt. Bitte bestätige die Angaben durch Aktivieren des Schalters."],
    ["Booking", "Buchung"],
    ["Confirm the payment and accept the", "Zahlung bestätigen und die"],
    ["Terms and Conditions", "Allgemeinen Geschäftsbedingungen akzeptieren"],
    ["Add", "Hinzufügen"],
    ["Remove", "Entfernen"],
    ["Reloading your selected information", "Lade die ausgewählten Informationen"],
    ["Your Trip", "Dein Reiseverlauf"],
    ["Your Selection", "Deine Auswahl"],
    ["Your Car Equipment", "Deine Fahrzeugausstattung"],
    ["Add a product first", "Bitte Produkte auswählen"],
    ["Book Now", "Jetzt buchen"],
    ["Your pending bookings", "Deine ausstehenden Buchungen"],
    ["Your confirmed bookings", "Deine bestätigten Buchungen"],
    ["Show my Bookings", "Buchungen anzeigen"],
    ["this link has expired", "Leider ist dieser Link nicht mehr gültig"],
    ["Page not found", "Seite nicht gefunden"],
    ["Free", "Gratis"],
    ["Equipment Shop", "Zubehör"],
    ["Pick Car Equipment For...", "Zubehör auswählen für..."],
    ["Select your interest", "Triff eine Auswahl und erhalte passende Empfehlungen."],
    ["View Locations", "Karte anzeigen"],
    ["Discover", "Entdecken"],
    ["My Experiences", "Meine Erlebnisse"],
    ["My Bookings", "Meine Buchungen"],
    ["Payment Information", "Zahlungsinformationen"],
    ["error payment submission.", "Leider ist bei der Übermittlung der Zahlung ein Fehler aufgetreten."],
    ["Please go back payment", "Gehe zur Startseite und versuche es erneut. Falls eine Zahlung bei Dir abgebucht wurde, setze Dich umgehend mit uns in Verbindung."],
    ["Go back", "Zur Startseite"],
    ["Checkout", "Bezahlen"],
    ["Card Number", "Kartennummer"],
    ["Cardholder Name", "Karteninhaber"],
    ["John Doe", "Max Mustermann"],
    ["Expiration Date", "Ablaufdatum"],
    ["CVV", "CVV"],
    ["The payment for this item didn't go through.", "Die Zahlung wurde abgelehnt."],
    ["mock card number", "Demo-Kartennumer"],
    ["mock expiry", "Demo-Ablaufdatum"],
    ["mock cvv", "Demo-cvv"],
    ["Final payment details will be listed", "Die endgültigen Zahlungsdaten werden während des Zahlungsvorgangs angegeben."],
    ["First name", "Vorname"],
    ["Last name", "Nachname"],
    ["Street and Number", "Straße und Hausnummer"],
    ["Postal code", "Postleitzahl"],
    ["City", "Stadt"],
    ["Country", "Land"],
    ["Email Address", "E-Mail-Adresse"],
    ["I confirm that the above information is correct", "Ich bestätige, dass die oben genannten Informationen korrekt sind."],
    ["Please use the following card", "Bitte verwende die folgenden Kreditkarten-Details, um mit der <span>DEMO</span>-Zahlung fortzufahren:"],
    ["Imprint", "Impressum"],
    ["Privacy Policy", "Datenschutzbestimmungen"],
    ["Terms of Use", "Nutzungsbedingungen"],
    ["booked the following equipment", "Du hast folgendes unvergessliches Erlebnis gebucht:"],
    ["call", "ANRUFEN"],
    ["email", "E-Mail"],
    ["Your booking is confirmed and invoice", "Deine Buchung ist bestätigt und wir senden Dir in Kürze eine Bestätigung per E-Mail. Die Rechnung des Dienstleisters erhältst Du bei Abholung der Ausrüstung."],
    ["If you wish to cancel", "Wenn Du die Buchung stornieren möchtest oder weitere Fragen hast, rufe bitte die oben genannte Nummer an."],
    ["Hello", "Hallo"],
    ["ORDER ID", "BESTELLNUMMER"],
    ["Clear all", "Alles löschen"],
    ["Available Offers", "Verfügbare Angebote"],
    ["to", "bis"],
    ["Start", "Beginn"],
    ["End", "Ende"],
    ["Create your individual trip", "Stelle Dir Deine individuelle Reise mit den Angeboten aus der Liste zusammen"],
    ["Add products and options", "Füge Produkte und Optionen aus der Liste hinzu"],
]);
